import ls from 'local-storage'
const TokenKey = 'token'

export function getToken() {
  return ls.get(TokenKey)
}

export function setToken(token) {
  return ls.set(TokenKey, token)
}

export function removeToken() {
  return ls.remove(TokenKey)
}

export function getPassword() {
  return ls.get('password')
}

export function setPassword(password) {
  return ls.set('password', password)
}

export function deletePassword() {
  return ls.remove('password')
}

export function getAccount() {
  return ls.get('account')
}

export function setAccount(account) {
  return ls.set('account', account)
}

export function deleteAccount() {
  return ls.remove('account')
}

export function setFullName(fullName) {
  return ls.set('fullName', encodeURIComponent(fullName))
}

export function getFullName() {
  return decodeURIComponent(ls.get('fullName'))
}

export function setUserName(userName) {
  return ls.set('userName', userName)
}

export function getUserName() {
  return ls.get('userName')
}

export function getHid() {
  return ls.get('hid')
}

export function setHid(hid) {
  return ls.set('hid', hid)
}

export function setDid(did) {
  return ls.set('did', did)
}

export function getDid() {
  return ls.get('did')
}

export function getHospitalName() {
  return ls.get('hospitalName')
}

export function setHospitalName(hospitalName) {
  return ls.set('hospitalName', hospitalName)
}

export function setExamineList(examineList) {
  return ls.set('examineList', examineList)
}

export function getExamineList() {
  return ls.get('examineList')
}

export function getSetting() {
  return ls.get('setting')
}

export function setSetting(settings) {
  return ls.set('setting', settings)
}

export const setUserInfoInls = info => {
  Object.keys(info).forEach(item => {
    ls.set(item, info[item])
  })
}
